import { render } from "./RdeMenu.vue?vue&type=template&id=4fc21044"
import script from "./RdeMenu.vue?vue&type=script&lang=js"
export * from "./RdeMenu.vue?vue&type=script&lang=js"

import "./RdeMenu.vue?vue&type=style&index=0&id=4fc21044&lang=css"

import exportComponent from "/Users/victorbello/Documents/Tizeti/Hotspot/eutelsat_branch/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__